// ───────────────────────────────────────────────────────────
// DO NOT EDIT — generated by scripts/generate-capability-names.cjs
// Source of truth: migrations/*.sql INSERT INTO capabilities ...
// Regenerate via: node scripts/generate-capability-names.cjs
// Verify in CI:   node scripts/generate-capability-names.cjs --check
// ───────────────────────────────────────────────────────────
// DEV-746 / ADR-001. The runtime evaluator works against capability
// names as strings; this file's purpose is to give every static call
// site of hasCapability(...) a compile-time guarantee that the cap
// name is one the system actually understands.
//
// Total: 45 capabilities — 30 project, 2 collection, 13 community.
// ───────────────────────────────────────────────────────────

/** Project-scope capability names. */
export type ProjectCapabilityName =
  | 'about:edit' // from 113_permissions_v2_capabilities.sql
  | 'about:publish' // from 113_permissions_v2_capabilities.sql
  | 'about:view' // from 113_permissions_v2_capabilities.sql
  | 'budget:edit' // from 113_permissions_v2_capabilities.sql
  | 'budget:view' // from 113_permissions_v2_capabilities.sql
  | 'contributions:edit' // from 113_permissions_v2_capabilities.sql
  | 'contributions:view' // from 113_permissions_v2_capabilities.sql
  | 'expert:edit' // from 113_permissions_v2_capabilities.sql
  | 'expert:view' // from 113_permissions_v2_capabilities.sql
  | 'forum:view' // from 113_permissions_v2_capabilities.sql
  | 'impact:edit' // from 113_permissions_v2_capabilities.sql
  | 'impact:view' // from 113_permissions_v2_capabilities.sql
  | 'media:moderate' // from 113_permissions_v2_capabilities.sql
  | 'media:upload' // from 113_permissions_v2_capabilities.sql
  | 'media:view' // from 113_permissions_v2_capabilities.sql
  | 'performance:edit' // from 113_permissions_v2_capabilities.sql
  | 'performance:view' // from 113_permissions_v2_capabilities.sql
  | 'project:admin' // from 113_permissions_v2_capabilities.sql
  | 'project:archive' // from 113_permissions_v2_capabilities.sql
  | 'project:settings' // from 113_permissions_v2_capabilities.sql
  | 'resources:edit' // from 113_permissions_v2_capabilities.sql
  | 'resources:view' // from 113_permissions_v2_capabilities.sql
  | 'risks:edit' // from 113_permissions_v2_capabilities.sql
  | 'risks:materialize' // from 113_permissions_v2_capabilities.sql
  | 'risks:view' // from 113_permissions_v2_capabilities.sql
  | 'schedule:edit' // from 113_permissions_v2_capabilities.sql
  | 'schedule:view' // from 113_permissions_v2_capabilities.sql
  | 'team:edit' // from 113_permissions_v2_capabilities.sql
  | 'team:manage' // from 113_permissions_v2_capabilities.sql
  | 'team:view'; // from 113_permissions_v2_capabilities.sql

/** Collection-scope capability names. */
export type CollectionCapabilityName =
  | 'collection:admin' // from 113_permissions_v2_capabilities.sql
  | 'collection:view'; // from 113_permissions_v2_capabilities.sql

/** Community-scope capability names. */
export type CommunityCapabilityName =
  | 'community:admin' // from 128_community_scope_capabilities.sql
  | 'community:admin_descendants' // from 128_community_scope_capabilities.sql
  | 'community:assign_roles' // from 128_community_scope_capabilities.sql
  | 'community:create_children' // from 128_community_scope_capabilities.sql
  | 'community:create_projects' // from 130_d3_community_bundles_and_create_projects_cap.sql
  | 'community:manage_blocked_domains' // from 155_community_content_curator_bundle.sql
  | 'community:manage_media' // from 155_community_content_curator_bundle.sql
  | 'community:manage_schemas' // from 128_community_scope_capabilities.sql
  | 'community:moderate_content' // from 155_community_content_curator_bundle.sql
  | 'community:reparent' // from 128_community_scope_capabilities.sql
  | 'community:settings' // from 128_community_scope_capabilities.sql
  | 'community:view' // from 128_community_scope_capabilities.sql
  | 'community:view_descendants'; // from 128_community_scope_capabilities.sql

/** Every capability name the V2 evaluator understands. */
export type CapabilityName =
  | ProjectCapabilityName
  | CollectionCapabilityName
  | CommunityCapabilityName;

/**
 * Runtime registry. Useful for "is this string a known cap?" checks at
 * the I/O boundary (e.g. parsing untyped JSON from a settings file).
 * Each entry tracks its source migration for trace / debugging.
 */
export const CAPABILITY_REGISTRY: ReadonlyArray<{
  readonly name: CapabilityName;
  readonly scopeType: 'project' | 'collection' | 'community';
  readonly sourceMigration: string;
}> = [
  { name: 'about:edit', scopeType: 'project', sourceMigration: '113_permissions_v2_capabilities.sql' },
  { name: 'about:publish', scopeType: 'project', sourceMigration: '113_permissions_v2_capabilities.sql' },
  { name: 'about:view', scopeType: 'project', sourceMigration: '113_permissions_v2_capabilities.sql' },
  { name: 'budget:edit', scopeType: 'project', sourceMigration: '113_permissions_v2_capabilities.sql' },
  { name: 'budget:view', scopeType: 'project', sourceMigration: '113_permissions_v2_capabilities.sql' },
  { name: 'collection:admin', scopeType: 'collection', sourceMigration: '113_permissions_v2_capabilities.sql' },
  { name: 'collection:view', scopeType: 'collection', sourceMigration: '113_permissions_v2_capabilities.sql' },
  { name: 'community:admin', scopeType: 'community', sourceMigration: '128_community_scope_capabilities.sql' },
  { name: 'community:admin_descendants', scopeType: 'community', sourceMigration: '128_community_scope_capabilities.sql' },
  { name: 'community:assign_roles', scopeType: 'community', sourceMigration: '128_community_scope_capabilities.sql' },
  { name: 'community:create_children', scopeType: 'community', sourceMigration: '128_community_scope_capabilities.sql' },
  { name: 'community:create_projects', scopeType: 'community', sourceMigration: '130_d3_community_bundles_and_create_projects_cap.sql' },
  { name: 'community:manage_blocked_domains', scopeType: 'community', sourceMigration: '155_community_content_curator_bundle.sql' },
  { name: 'community:manage_media', scopeType: 'community', sourceMigration: '155_community_content_curator_bundle.sql' },
  { name: 'community:manage_schemas', scopeType: 'community', sourceMigration: '128_community_scope_capabilities.sql' },
  { name: 'community:moderate_content', scopeType: 'community', sourceMigration: '155_community_content_curator_bundle.sql' },
  { name: 'community:reparent', scopeType: 'community', sourceMigration: '128_community_scope_capabilities.sql' },
  { name: 'community:settings', scopeType: 'community', sourceMigration: '128_community_scope_capabilities.sql' },
  { name: 'community:view', scopeType: 'community', sourceMigration: '128_community_scope_capabilities.sql' },
  { name: 'community:view_descendants', scopeType: 'community', sourceMigration: '128_community_scope_capabilities.sql' },
  { name: 'contributions:edit', scopeType: 'project', sourceMigration: '113_permissions_v2_capabilities.sql' },
  { name: 'contributions:view', scopeType: 'project', sourceMigration: '113_permissions_v2_capabilities.sql' },
  { name: 'expert:edit', scopeType: 'project', sourceMigration: '113_permissions_v2_capabilities.sql' },
  { name: 'expert:view', scopeType: 'project', sourceMigration: '113_permissions_v2_capabilities.sql' },
  { name: 'forum:view', scopeType: 'project', sourceMigration: '113_permissions_v2_capabilities.sql' },
  { name: 'impact:edit', scopeType: 'project', sourceMigration: '113_permissions_v2_capabilities.sql' },
  { name: 'impact:view', scopeType: 'project', sourceMigration: '113_permissions_v2_capabilities.sql' },
  { name: 'media:moderate', scopeType: 'project', sourceMigration: '113_permissions_v2_capabilities.sql' },
  { name: 'media:upload', scopeType: 'project', sourceMigration: '113_permissions_v2_capabilities.sql' },
  { name: 'media:view', scopeType: 'project', sourceMigration: '113_permissions_v2_capabilities.sql' },
  { name: 'performance:edit', scopeType: 'project', sourceMigration: '113_permissions_v2_capabilities.sql' },
  { name: 'performance:view', scopeType: 'project', sourceMigration: '113_permissions_v2_capabilities.sql' },
  { name: 'project:admin', scopeType: 'project', sourceMigration: '113_permissions_v2_capabilities.sql' },
  { name: 'project:archive', scopeType: 'project', sourceMigration: '113_permissions_v2_capabilities.sql' },
  { name: 'project:settings', scopeType: 'project', sourceMigration: '113_permissions_v2_capabilities.sql' },
  { name: 'resources:edit', scopeType: 'project', sourceMigration: '113_permissions_v2_capabilities.sql' },
  { name: 'resources:view', scopeType: 'project', sourceMigration: '113_permissions_v2_capabilities.sql' },
  { name: 'risks:edit', scopeType: 'project', sourceMigration: '113_permissions_v2_capabilities.sql' },
  { name: 'risks:materialize', scopeType: 'project', sourceMigration: '113_permissions_v2_capabilities.sql' },
  { name: 'risks:view', scopeType: 'project', sourceMigration: '113_permissions_v2_capabilities.sql' },
  { name: 'schedule:edit', scopeType: 'project', sourceMigration: '113_permissions_v2_capabilities.sql' },
  { name: 'schedule:view', scopeType: 'project', sourceMigration: '113_permissions_v2_capabilities.sql' },
  { name: 'team:edit', scopeType: 'project', sourceMigration: '113_permissions_v2_capabilities.sql' },
  { name: 'team:manage', scopeType: 'project', sourceMigration: '113_permissions_v2_capabilities.sql' },
  { name: 'team:view', scopeType: 'project', sourceMigration: '113_permissions_v2_capabilities.sql' },
] as const;

export const CAPABILITY_NAMES: ReadonlySet<CapabilityName> = new Set(
  CAPABILITY_REGISTRY.map((c) => c.name)
);

export function isKnownCapability(name: string): name is CapabilityName {
  return CAPABILITY_NAMES.has(name as CapabilityName);
}
